import dayjs from 'dayjs'

const LUCENE_SPECIAL_CHARS = /[+!(){}[\]^"~*?:\\/-]/g

export const escapeLuceneValue = (value: string): string =>
  value.replaceAll(LUCENE_SPECIAL_CHARS, char => `\\${char}`)

export const formatLuceneDate = (date: dayjs.ConfigType): string =>
  dayjs(date)
    .toISOString()
    .replace(/\.\d+Z$/, 'Z')

export const luceneField = (name: string, value: string): string =>
  `${name}:${escapeLuceneValue(value)}`

export const lucenePhrase = (name: string, value: string): string =>
  `${name}:"${escapeLuceneValue(value)}"`

export const luceneAnyOf = (name: string, values: readonly string[]): string => {
  if (values.length === 1) return luceneField(name, values[0])
  return `${name}:(${values.map(escapeLuceneValue).join(' OR ')})`
}

export const joinLuceneQuery = (
  parts: ReadonlyArray<string | false | null | undefined>,
  separator: ' AND ' | ' OR ' | ' ' = ' AND '
): string | undefined => {
  const clauses = parts.filter((part): part is string => Boolean(part))
  return clauses.length ? clauses.join(separator) : undefined
}
